export const BROWSER_STORAGE_KEYS = {
  HAS_PASSWORD: 'has_password',
  UNPAID_INVOICE_POPUP_SEEN: 'unpaid_invoice_popup_seen',
}
